export const trimStart = (value: string): string => {
  return value.trimStart();
};

export const trimInput = (value: string): string => {
  return value.trim();
};

export const verifyFileHeader = async (file: File): Promise<boolean> => {
  return new Promise((resolve) => {
    const reader = new FileReader();
    
    const blob = file.slice(0, 4); 
    
    reader.onloadend = (e) => {
      if (e.target?.readyState === FileReader.DONE) {
        const uint = new Uint8Array(e.target.result as ArrayBuffer);
        let bytes: string[] = [];
        uint.forEach((byte) => {
          bytes.push(byte.toString(16).padStart(2, '0'));
        });
        const hex = bytes.join('').toUpperCase();

        const isZip = hex === '504B0304' || hex === '504B0506' || hex === '504B0708';
        const isExe = hex.startsWith('4D5A');

        resolve(isZip || isExe);
      }
    };
    
    reader.onerror = () => resolve(false);
    reader.readAsArrayBuffer(blob);
  });
};